export default __webpack_public_path__ + "static/media/LinkedIn.17f75ba5.png";